import { connect } from 'react-redux';
import LoyaltyWidget from './LoyaltyWidget';

const mapStateToProps = ({ agency, purchase }) => ({
  visible: !agency.get('agency'),
  fetchingPurchase: purchase.get('isFetching') || purchase.get('isUpdating'),
});

export default connect(mapStateToProps)(LoyaltyWidget);
